import React from 'react';
import TextInput from './TextInput';

const PasswordInput = props => (
    <TextInput {...props} type="password" />
);

export default PasswordInput;
